import Block from '../block'

export default class Social extends Block {
    static title = 'social'

    init() {
        this.icons = this.getElements('icon[data-service]')
        this.icons.forEach(icon => {
            icon.addEventListener('click', () => this.share(icon))
        })
    }

    share(shareElement) {
        let url
        switch (shareElement.dataset.service) {
            case 'facebook':
                url = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
                    this.element.dataset.url
                )}&display=popup`
                break

            case 'linkedin':
                url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                    this.element.dataset.url
                )}&source=LinkedIn`
                break

            case 'twitter':
                url = `https://twitter.com/intent/tweet?url=${this.element.dataset.url}`
                if (this.element.dataset.title) {
                    url += `&text=${encodeURIComponent(this.element.dataset.title)}`
                }
                break

            default:
                if (process.env.NODE_ENV === 'development') {
                    console.error('invalid share service provided')
                }
                break
        }

        this.openPopup(url)
    }

    openPopup(url) {
        if (!url) {
            return
        }

        let popupWindow = window.open(url, 'Share', 'height=400,width=600')
        if (window.focus) {
            popupWindow.focus()
        }
        return false
    }
}
